import { Link } from "wouter";
import { useTranslation } from "react-i18next";

type Props = {
  title: string;
  back?: string;
  children?: React.ReactNode;
};

export function PageStub({ title, back = "/home", children }: Props) {
  const { t } = useTranslation();
  return (
    <main className="min-h-dvh flex flex-col items-center justify-center px-6 py-12 text-center bg-[var(--color-night)] text-[var(--color-washi)]">
      <h1
        className="text-3xl font-[var(--font-fude)] text-[var(--color-gold)] mb-4 tracking-[0.2em]"
        style={{ fontFamily: "var(--font-fude)" }}
      >
        {title}
      </h1>
      <p className="text-sm opacity-60 mb-8">{t("common.soon")}</p>
      {children}
      <Link
        href={back}
        className="mt-12 text-sm text-[var(--color-gold-light)] underline-offset-4 hover:underline"
      >
        ← {t("common.back")}
      </Link>
    </main>
  );
}
